exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-gops.js
// module id = 37
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/core-js/library/modules/_object-gops.js